









































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Tache} from '@/models';

import CrudTacheFilter from '@/components/Crud/Tache/Filter.vue';
import CrudTacheEditDialog from '@/components/Crud/Tache/EditDialog.vue';
import CrudTacheList from '@/components/Crud/Tache/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeTache, {TacheFilter} from '@/stores/modules/tache';

@Component({
	components: {
		CrudTacheFilter,
		CrudTacheEditDialog,
		CrudTacheList,
		CrudDeleteDialog,
	}
})
export default class TacheView extends Vue {

	@Stored(() => storeTache) private taches!: ResultType<Tache>;
	@Stored(() => storeTache) private filters!: TacheFilter;

	private imgPath: string = "";

	private editTache: Tache = null;
	private deletedTache: Tache = null;
	private storeTache = storeTache;
	private list;

	public mounted() {
		this.list = this.$refs['list'] as CrudTacheList
	}

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editTache = new Tache();
		this.refresh();
	}

	private refresh(): void {
		storeTache.dispatch('getC', { filters: true });
	}
}
